<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <div class="discount-code" *ngIf="show_discount_code">
    24小時自助解鎖Tesla限時75折優惠碼
    <span>Q67KY</span>
    <ion-icon (click)="show_discount_code = false" name="close-circle-outline"></ion-icon>
  </div>
</ion-app>
